import {PROGRESS_CHANGE,PROGRESS_CHANGE_NO} from  "../actions/types";


const INITIAL_STATE = {
    changePage:true,
};

export default (state=INITIAL_STATE ,action)=>{
    switch(action.type) {
        case PROGRESS_CHANGE:
            return {
                changePage:false
            }
        case PROGRESS_CHANGE_NO:
            return {
                changePage:true
            }
        default:
            return state
    }
}


























